import { createReducer } from 'store/createReducer';
import { StepperModel } from 'models/StepperModel';
import { STEP_NEXT, STEP_PREV, STEP_ADDEDTOCART, STEP_ADDINGTOCART } from './actions';

const stepperReducer = {
  [STEP_NEXT]: (state: StepperModel) => {
    return {
      ...state,
      currentStep: state.currentStep + 1
    };
  },
  [STEP_PREV]: (state: StepperModel) => {
    return {
      ...state,
      currentStep: state.currentStep - 1
    };
  },
  [STEP_ADDEDTOCART]: (state: StepperModel) => {
    return {
      ...state,
      addedToCart: true,
      addingToCart: false
    };
  },
  [STEP_ADDINGTOCART]: (state: StepperModel) => {
    return {
      ...state,
      addingToCart: true
    };
  }
};

export default createReducer(
  {
    currentStep: 1,
    addedToCart: false,
    addingToCart: false
  },
  stepperReducer
);
